<script>
  import Central from "./Central.svelte";
  import Login from "./Login.svelte";
  import Mapa from "./Mapa.svelte";
  import Mapa_travel from "./Mapa_travel.svelte";
  import Embed_dtc from "./Embed_dtc.svelte";
  import Embed_ecm from "./Embed_ecm.svelte";
  import Embed_mensajes from "./Embed_mensajes.svelte";
  import Embed_recorridos from "./Embed_recorridos.svelte";
  import Embed_monitor from "./Embed_monitor.svelte";
  import Travel_app from "./Travel_app.svelte";
  import DriverApp from "./Driver_app.svelte";
  import { get } from "svelte/store";
  import {
    createSocketOptions,
    getWorkerBootstrapDelayMs,
    scheduleHelloWithJitter,
  } from "./socket-client-options.js";
  import { getKnownServiceWorkerCacheNumber } from "./service-worker-update.js";

  import {
    table_pos,
    units_list,
    nicks_list,
    geos,
    geos_class,
    geos_class_list,
    menu,
    travels,
    route_list,
    live,
    drivers_list,
    drivers,
    route_list_d,
    travel_crtl,
    zones_list,
    zones,
    geos_joined,
    geos_class_join,
    map_ready,
    travels_list,
    unit_groups,
    geos_full,
    geo_class_full,
    zone_full,
    unit_config,
    unit_types,
    reports_cron,
    portal_version,
    route_list_nosig,
    route_list_nosig_d,
    dtc_count,
    poli_list,
    poli,
    poli_full,
    geos_map,
    users_list,
    alerts_list,
    reports,
    group,
    driver_name,
    driver_id,
    driver_reports,
    last_message_date,
    hos_config,
    genesys_key,
    continue_recording,
    unit_list_ws,
    unit_list_ws_real,
    alert_management,
    custom_options,
    route_confidence,
    input_self_test,
    login_feedback,
    login_feedback_default,
  } from "./stores.js";
  let serverdb =
    "https://" + document.getElementById("ws_server").getAttribute("value");
  localforage.setDriver(localforage.INDEXEDDB);
  //const base_db = localforage.createInstance({name: "base_1_db"});
  //const units_db = localforage.createInstance({name: "units_1_db"});
  //const geos_db = localforage.createInstance({name: "geos_1_db"});
  //const geos_class_db = localforage.createInstance({name: "geos__class_1_db"});
  const units_travel_db = localforage.createInstance({
    name: "units_travel_1_db",
  });
  const routes_db = localforage.createInstance({ name: "routes_1_db" });
  const monitor_db = localforage.createInstance({ name: "monitor_1_db" });
  const chats_db = localforage.createInstance({ name: "chats_1_db" });
  const vins_db = localforage.createInstance({ name: "vins_1_db" });
  const ecm_db = localforage.createInstance({ name: "ecm_1_db" });
  const dtc_db = localforage.createInstance({ name: "dtc_1_db" });
  const travel_db = localforage.createInstance({ name: "travel_1_db" });

  const unit_list_db = localforage.createInstance({ name: "unit_list_1_db" });
  const nick_list_db = localforage.createInstance({ name: "nick_list_1_db" });
  const driver_list_db = localforage.createInstance({ name: "driver_list_1_db" });
  const route_list_db = localforage.createInstance({ name: "route_list_1_db" });
  const route_list_nosig_db = localforage.createInstance({
    name: "route_list_nosig_1_db",
  });
  const units_groups_db = localforage.createInstance({
    name: "units_groups_1_db",
  });
  const login_db = localforage.createInstance({ name: "login_1_db" });
  const travel_crtl_db = localforage.createInstance({
    name: "travel_crtl_1_db",
  });
  const zone_list_db = localforage.createInstance({ name: "zone_list_1_db" });
  const geo__db = localforage.createInstance({ name: "geo__1_db" });
  const geo_class_list_db = localforage.createInstance({
    name: "geo_class_list_1_db",
  });
  const geos_joined_db = localforage.createInstance({ name: "geos_joined_1_db" });
  const geos_class__db = localforage.createInstance({
    name: "geos_class__1_db",
  });
  const geos_class_join_db = localforage.createInstance({
    name: "geos_class_join_1_db",
  });
  const geo_list_wks_db = localforage.createInstance({
    name: "geo_list_wks_1_db",
  });
  const poli_list_db = localforage.createInstance({
    name: "poli_list_1_db",
  });
  const poli__db = localforage.createInstance({
    name: "poli__1_db",
  });

  const protocol_db = localforage.createInstance({ name: "protocol_1_db" });
  const MONITOR_LIVE_CACHE_KEY = "monitor_live_snapshot";
  const MONITOR_TRAVELS_CACHE_KEY = "monitor_travels_snapshot";
  const MONITOR_CACHE_WRITE_DEBOUNCE_MS = 750;
  const MONITOR_WORKER_MAIN_THREAD_BATCH_MS = 32;
  const pendingMonitorCacheWrites = {};
  const monitorCacheWriteTimers = {};
  let hydratedMonitorLiveSnapshot = {};
  let hydratedMonitorTravelsSnapshot = {};

  const socket_query = io(serverdb, createSocketOptions("query"));
  const SESSION_TOUCH_INTERVAL_MS = 30 * 1000;
  const QUERY_TAB_ID_STORAGE_KEY = "vector_query_tab_id";
  const MIN_HELLO_GAP_MS = 1200;
  const LOGIN_RESTORE_SLOW_MS = 4000;
  const LOGIN_RESTORE_TIMEOUT_MS = 22000;
  const PORTAL_BOOTSTRAP_SLOW_MS = 4000;
  const PORTAL_BOOTSTRAP_TIMEOUT_MS = 12000;
  const PORTAL_BOOTSTRAP_TIMEOUT_HIDE_MS = 2500;
  const PORTAL_BOOTSTRAP_STEP_LABELS = {
    units: "Unidades",
    monitor: "Monitoreo",
    trips: "Viajes",
    routes: "Rutas",
    geos: "Geocercas",
    config: "Configuración",
  };
  const PORTAL_BOOTSTRAP_STEP_ORDER = Object.keys(PORTAL_BOOTSTRAP_STEP_LABELS);
  let session_touch_timer = null;
  let lastHelloEmitAt = 0;
  let login_state_ready = window.location.pathname != "/";
  let restoring_session = false;
  let restoreFeedbackTimer = null;
  let restoreFeedbackTimeoutTimer = null;
  let portalBootstrapSlowTimer = null;
  let portalBootstrapTimeoutTimer = null;
  let portalBootstrapHideTimer = null;
  let portalBootstrapSignals = PORTAL_BOOTSTRAP_STEP_ORDER.reduce(
    (out, key) => {
      out[key] = false;
      return out;
    },
    {}
  );

  function buildLoginFeedback(overrides = {}) {
    return {
      ...login_feedback_default,
      ...overrides,
    };
  }

  function setLoginFeedbackState(overrides = {}) {
    login_feedback.set(buildLoginFeedback(overrides));
  }

  function clearRestoreFeedbackTimer() {
    if (restoreFeedbackTimer) {
      clearTimeout(restoreFeedbackTimer);
      restoreFeedbackTimer = null;
    }
    if (restoreFeedbackTimeoutTimer) {
      clearTimeout(restoreFeedbackTimeoutTimer);
      restoreFeedbackTimeoutTimer = null;
    }
  }

  function clearPortalBootstrapTimers() {
    if (portalBootstrapSlowTimer) {
      clearTimeout(portalBootstrapSlowTimer);
      portalBootstrapSlowTimer = null;
    }
    if (portalBootstrapTimeoutTimer) {
      clearTimeout(portalBootstrapTimeoutTimer);
      portalBootstrapTimeoutTimer = null;
    }
    if (portalBootstrapHideTimer) {
      clearTimeout(portalBootstrapHideTimer);
      portalBootstrapHideTimer = null;
    }
  }

  function resetPortalBootstrapSignals() {
    portalBootstrapSignals = PORTAL_BOOTSTRAP_STEP_ORDER.reduce((out, key) => {
      out[key] = false;
      return out;
    }, {});
  }

  function getCompletedPortalBootstrapCount() {
    return PORTAL_BOOTSTRAP_STEP_ORDER.filter((key) => portalBootstrapSignals[key])
      .length;
  }

  function buildPortalBootstrapSteps() {
    return PORTAL_BOOTSTRAP_STEP_ORDER.map((key) => ({
      key,
      label: PORTAL_BOOTSTRAP_STEP_LABELS[key],
      done: !!portalBootstrapSignals[key],
    }));
  }

  function refreshPortalBootstrapFeedback(options = {}) {
    const completed = getCompletedPortalBootstrapCount();
    const total = PORTAL_BOOTSTRAP_STEP_ORDER.length;
    let detail = options.forceDetail;
    if (!detail) {
      if (completed === 0) {
        detail = "Preparando rutas, geocercas y datos base del portal...";
      } else if (completed < total) {
        detail = "Sincronizando catálogos iniciales para terminar de abrir el panel.";
      } else {
        detail = "Datos base listos.";
      }
    }
    setLoginFeedbackState({
      active: true,
      phase: "loading-panel",
      source: "post-login",
      title: completed >= total ? "Panel listo" : "Cargando panel",
      detail,
      slow: !!options.slow,
      progress: total === 0 ? 0 : completed / total,
      completed,
      total,
      steps: buildPortalBootstrapSteps(),
    });
  }

  function finishPortalBootstrap() {
    clearPortalBootstrapTimers();
    const currentFeedback = get(login_feedback);
    if (
      currentFeedback.phase === "loading-panel" &&
      currentFeedback.source === "post-login"
    ) {
      setLoginFeedbackState();
    }
  }

  function registerPortalBootstrapSignal(key) {
    if (!PORTAL_BOOTSTRAP_STEP_LABELS[key] || portalBootstrapSignals[key]) {
      return;
    }
    portalBootstrapSignals = {
      ...portalBootstrapSignals,
      [key]: true,
    };
    const currentFeedback = get(login_feedback);
    if (
      currentFeedback.phase === "loading-panel" &&
      currentFeedback.source === "post-login"
    ) {
      if (
        getCompletedPortalBootstrapCount() >= PORTAL_BOOTSTRAP_STEP_ORDER.length
      ) {
        finishPortalBootstrap();
      } else {
        refreshPortalBootstrapFeedback({ slow: currentFeedback.slow });
      }
    }
  }

  function beginStoredSessionRestoreFeedback() {
    restoring_session = true;
    resetPortalBootstrapSignals();
    clearRestoreFeedbackTimer();
    clearPortalBootstrapTimers();
    setLoginFeedbackState({
      active: true,
      phase: "restoring-session",
      source: "restore",
      title: "Restaurando sesión",
      detail: "Reconectando con tu sesión guardada...",
    });
    restoreFeedbackTimer = setTimeout(() => {
      const currentFeedback = get(login_feedback);
      if (
        currentFeedback.phase !== "restoring-session" ||
        currentFeedback.source !== "restore"
      ) {
        return;
      }
      login_feedback.set({
        ...currentFeedback,
        slow: true,
        detail:
          "Seguimos esperando respuesta del servidor. Puedes cambiar de cuenta si lo prefieres.",
      });
    }, LOGIN_RESTORE_SLOW_MS);
    restoreFeedbackTimeoutTimer = setTimeout(() => {
      const currentFeedback = get(login_feedback);
      if (
        currentFeedback.phase !== "restoring-session" ||
        currentFeedback.source !== "restore"
      ) {
        return;
      }
      login_feedback.set({
        ...currentFeedback,
        slow: true,
        detail:
          "No hubo respuesta del servidor. Puedes descartar la sesión guardada e ingresar otra vez.",
      });
    }, LOGIN_RESTORE_TIMEOUT_MS);
  }

  function beginPortalBootstrap() {
    restoring_session = false;
    clearRestoreFeedbackTimer();
    clearPortalBootstrapTimers();
    refreshPortalBootstrapFeedback();
    if (getCompletedPortalBootstrapCount() >= PORTAL_BOOTSTRAP_STEP_ORDER.length) {
      finishPortalBootstrap();
      return;
    }
    portalBootstrapSlowTimer = setTimeout(() => {
      const currentFeedback = get(login_feedback);
      if (
        currentFeedback.phase !== "loading-panel" ||
        currentFeedback.source !== "post-login"
      ) {
        return;
      }
      refreshPortalBootstrapFeedback({
        slow: true,
        forceDetail:
          "Seguimos cargando el panel. Puedes empezar a usarlo mientras termina la sincronización.",
      });
    }, PORTAL_BOOTSTRAP_SLOW_MS);
    portalBootstrapTimeoutTimer = setTimeout(() => {
      const currentFeedback = get(login_feedback);
      if (
        currentFeedback.phase !== "loading-panel" ||
        currentFeedback.source !== "post-login"
      ) {
        return;
      }
      refreshPortalBootstrapFeedback({
        slow: true,
        forceDetail:
          "Algunos datos siguen llegando. El portal continuará sincronizando en segundo plano.",
      });
      portalBootstrapHideTimer = setTimeout(() => {
        const latestFeedback = get(login_feedback);
        if (
          latestFeedback.phase === "loading-panel" &&
          latestFeedback.source === "post-login"
        ) {
          setLoginFeedbackState();
        }
      }, PORTAL_BOOTSTRAP_TIMEOUT_HIDE_MS);
    }, PORTAL_BOOTSTRAP_TIMEOUT_MS);
  }

  async function resetPortalToLogin({
    alertMessage = "",
    alertType = "",
  } = {}) {
    restoring_session = false;
    login_state_ready = true;
    clearRestoreFeedbackTimer();
    clearPortalBootstrapTimers();
    resetPortalBootstrapSignals();
    stopSessionTouch();
    menu.set(0);
    window.document.body.classList.remove("central2");
    try {
      await login_db.setItem("login_", "");
      await login_db.setItem("menu_base", 0);
    } catch (_error) {}
    setLoginFeedbackState({
      alertMessage,
      alertType,
    });
  }

  function generateRuntimeId() {
    return (
      Date.now().toString(36) + "-" + Math.random().toString(36).slice(2, 10)
    );
  }

  function getOrCreateQueryTabId() {
    let tabId = sessionStorage.getItem(QUERY_TAB_ID_STORAGE_KEY);
    if (!tabId) {
      tabId = generateRuntimeId();
      sessionStorage.setItem(QUERY_TAB_ID_STORAGE_KEY, tabId);
    }
    return tabId;
  }

  function buildQuerySessionMeta() {
    return {
      tab_id: getOrCreateQueryTabId(),
      route: window.location.pathname,
      visibility: document.visibilityState || "visible",
      // Se persiste en la sesion para poder identificar que cache real tiene cada pantalla conectada.
      cache_number: getKnownServiceWorkerCacheNumber(),
    };
  }

  async function ensureLoginKey() {
    let id = await login_db.getItem("key");
    if (!id) {
      id = new Date().valueOf().toString();
      await login_db.setItem("key", id);
    }
    return id;
  }

  async function emitStoredHello() {
    const now = Date.now();
    if (now - lastHelloEmitAt < MIN_HELLO_GAP_MS) {
      return;
    }
    const id = await ensureLoginKey();
    let login_ = await login_db.getItem("login_");
    if (!login_) {
      login_ = "";
      await login_db.setItem("login_", login_);
      return;
    }
    if (login_ != "") {
      lastHelloEmitAt = now;
      scheduleHelloWithJitter("query", () => {
        socket_query.emit(
          "hello",
          login_,
          id,
          $portal_version,
          window.screen.width + "x" + window.screen.height,
          buildQuerySessionMeta()
        );
      });
    }
  }

  async function hydrateStoredSessionState() {
    if (window.location.pathname != "/") {
      login_state_ready = true;
      return;
    }
    try {
      let menu_base = await login_db.getItem("menu_base");
      if (menu_base == null) {
        menu_base = 0;
        await login_db.setItem("menu_base", menu_base);
      }

      const stored_login = await login_db.getItem("login_");
      const hasStoredLogin =
        typeof stored_login === "string" && stored_login.trim() !== "";

      if (hasStoredLogin) {
        beginStoredSessionRestoreFeedback();
        if (menu_base) {
          menu.set(menu_base);
          window.document.body.classList.add("central2");
        }
      } else {
        restoring_session = false;
        clearRestoreFeedbackTimer();
        if (menu_base) {
          await login_db.setItem("menu_base", 0);
        }
        menu.set(0);
        window.document.body.classList.remove("central2");
        if (get(login_feedback).phase === "restoring-session") {
          setLoginFeedbackState();
        }
      }
    } catch (_error) {
      restoring_session = false;
      clearRestoreFeedbackTimer();
      resetPortalBootstrapSignals();
      menu.set(0);
      window.document.body.classList.remove("central2");
      setLoginFeedbackState({
        alertMessage:
          "No se pudo recuperar la sesión guardada. Ingresa tus credenciales para continuar.",
        alertType: "alert-warning",
      });
    }

    login_state_ready = true;
  }

  function scheduleWorkerBootstrap(type, setupFn) {
    setTimeout(() => {
      setupFn();
    }, getWorkerBootstrapDelayMs(type));
  }

  function parseCachedJson(rawValue, fallbackValue) {
    if (rawValue == null || rawValue === "") {
      return fallbackValue;
    }
    if (typeof rawValue === "string") {
      try {
        return JSON.parse(rawValue);
      } catch (_error) {
        return fallbackValue;
      }
    }
    return rawValue;
  }

  function normalizeCachedDriversList(rawDriversList) {
    if (!Array.isArray(rawDriversList)) {
      return [];
    }

    const normalized = [];
    for (const item of rawDriversList) {
      if (!Array.isArray(item) || item.length < 2 || !item[0]) {
        continue;
      }

      const driverId = item[0];
      const driverData =
        item[1] && typeof item[1] === "object" ? { ...item[1] } : {};

      normalized.push([driverId, driverData]);
    }

    normalized.sort((a, b) => {
      const leftName =
        a[1] && typeof a[1].name === "string" && a[1].name.trim() !== ""
          ? a[1].name
          : a[0];
      const rightName =
        b[1] && typeof b[1].name === "string" && b[1].name.trim() !== ""
          ? b[1].name
          : b[0];
      return leftName.localeCompare(rightName);
    });

    return normalized;
  }

  function buildDriversMapFromList(driverList) {
    const driverMap = {};

    for (const item of driverList) {
      if (!Array.isArray(item) || item.length < 2 || !item[0]) {
        continue;
      }
      driverMap[item[0]] = item[1] && typeof item[1] === "object" ? item[1] : {};
    }

    return driverMap;
  }

  function buildCatalogMapFromPairs(items) {
    const catalog = {};

    if (!Array.isArray(items)) {
      return catalog;
    }

    for (const item of items) {
      if (!Array.isArray(item) || item.length < 2 || !item[0]) {
        continue;
      }
      catalog[item[0]] = item[1];
    }

    return catalog;
  }

  function normalizeGeoListWks(rawGeoListWks) {
    if (!rawGeoListWks || typeof rawGeoListWks !== "object") {
      return {
        geosList: [],
        geosFullMap: {},
      };
    }

    const geosList = [];
    const geosFullMap = {};

    for (const geoId of Object.keys(rawGeoListWks)) {
      const parsedGeo = parseCachedJson(rawGeoListWks[geoId], null);
      if (!parsedGeo || typeof parsedGeo !== "object") {
        continue;
      }

      geosFullMap[geoId] = parsedGeo;
      if (typeof parsedGeo.join === "undefined" && Array.isArray(parsedGeo.pos)) {
        geosList.push([geoId, parsedGeo.pos]);
      }
    }

    return {
      geosList,
      geosFullMap,
    };
  }

  function buildGeoClassFull(rawGeoClassList) {
    const geoClassFullMap = {};

    if (!Array.isArray(rawGeoClassList)) {
      return geoClassFullMap;
    }

    for (const item of rawGeoClassList) {
      if (!Array.isArray(item) || item.length < 3 || !item[0]) {
        continue;
      }

      geoClassFullMap[item[0]] = {
        name: item[1],
        type: item[2],
      };
    }

    return geoClassFullMap;
  }

  function buildZoneStores(rawZoneList) {
    const zoneMap = {};
    const zoneFullMap = {};

    if (!Array.isArray(rawZoneList)) {
      return {
        zoneMap,
        zoneFullMap,
      };
    }

    for (const item of rawZoneList) {
      if (!Array.isArray(item) || item.length < 4 || !item[0]) {
        continue;
      }

      zoneMap[item[0]] = [item[1], item[2], item[3]];
      zoneFullMap[item[0]] = {
        pos: item[1],
        name: item[2],
        radio: item[3],
      };
    }

    return {
      zoneMap,
      zoneFullMap,
    };
  }

  function buildPoliStores(rawPoliList) {
    const poliMap = {};
    const poliFullMap = {};

    if (!Array.isArray(rawPoliList)) {
      return {
        poliMap,
        poliFullMap,
      };
    }

    for (const item of rawPoliList) {
      if (!Array.isArray(item) || item.length < 6 || !item[0]) {
        continue;
      }

      poliMap[item[0]] = [item[1], item[2], item[3], item[4], item[5]];
      poliFullMap[item[0]] = {
        pos: item[1],
        name: item[2],
        type: item[3],
        nicks: item[4],
        order: item[5],
      };
    }

    return {
      poliMap,
      poliFullMap,
    };
  }

  function scheduleMonitorCachePersist(cacheKey, nextValue) {
    if (!nextValue || typeof nextValue !== "object") {
      return;
    }

    pendingMonitorCacheWrites[cacheKey] = nextValue;
    if (monitorCacheWriteTimers[cacheKey]) {
      return;
    }

    monitorCacheWriteTimers[cacheKey] = setTimeout(async () => {
      monitorCacheWriteTimers[cacheKey] = null;
      const snapshot = pendingMonitorCacheWrites[cacheKey];
      delete pendingMonitorCacheWrites[cacheKey];

      try {
        await monitor_db.setItem(cacheKey, JSON.stringify(snapshot));
      } catch (_error) {}
    }, MONITOR_CACHE_WRITE_DEBOUNCE_MS);
  }

  async function hydrateInitialCatalogCache() {
    try {
      const [
        cachedUnitListRaw,
        cachedNickListRaw,
        cachedDriverListRaw,
        cachedRouteListRaw,
        cachedRouteListNoSigRaw,
        cachedUnitGroupsRaw,
        cachedTravelCrtlRaw,
        cachedGeoListRaw,
        cachedGeoListWksRaw,
        cachedGeoClassListRaw,
        cachedGeosClassRaw,
        cachedGeosJoinedRaw,
        cachedGeosClassJoinRaw,
        cachedZoneListRaw,
        cachedPoliListRaw,
        cachedPoliRaw,
        cachedMonitorLiveRaw,
        cachedMonitorTravelsRaw,
      ] = await Promise.all([
        unit_list_db.getItem("unit_list"),
        nick_list_db.getItem("nick_list"),
        driver_list_db.getItem("driver_list"),
        route_list_db.getItem("route_list"),
        route_list_nosig_db.getItem("route_list_nosig"),
        units_groups_db.getItem("units_groups"),
        travel_crtl_db.getItem("travel_crtl"),
        geo__db.getItem("geo_"),
        geo_list_wks_db.getItem("geo_list_wks"),
        geo_class_list_db.getItem("geo_class_list"),
        geos_class__db.getItem("geos_class_"),
        geos_joined_db.getItem("geos_joined"),
        geos_class_join_db.getItem("geos_class_join"),
        zone_list_db.getItem("zone_list"),
        poli_list_db.getItem("poli_list"),
        poli__db.getItem("poli_"),
        monitor_db.getItem(MONITOR_LIVE_CACHE_KEY),
        monitor_db.getItem(MONITOR_TRAVELS_CACHE_KEY),
      ]);

      const cachedUnitList = parseCachedJson(cachedUnitListRaw, []);
      if (Array.isArray(cachedUnitList) && cachedUnitList.length > 0) {
        units_list.set([...cachedUnitList]);
      }

      const cachedNickList = parseCachedJson(cachedNickListRaw, {});
      if (cachedNickList && typeof cachedNickList === "object") {
        nicks_list.set(cachedNickList);
      }

      const normalizedDriversList = normalizeCachedDriversList(
        parseCachedJson(cachedDriverListRaw, [])
      );
      if (normalizedDriversList.length > 0) {
        drivers_list.set(normalizedDriversList);
        drivers.set(buildDriversMapFromList(normalizedDriversList));
      }

      const cachedRouteList = parseCachedJson(cachedRouteListRaw, []);
      if (Array.isArray(cachedRouteList) && cachedRouteList.length > 0) {
        route_list.set([...cachedRouteList]);
        route_list_d.set(buildCatalogMapFromPairs(cachedRouteList));
      }

      const cachedRouteListNoSig = parseCachedJson(cachedRouteListNoSigRaw, []);
      if (
        Array.isArray(cachedRouteListNoSig) &&
        cachedRouteListNoSig.length > 0
      ) {
        route_list_nosig.set([...cachedRouteListNoSig]);
        route_list_nosig_d.set(buildCatalogMapFromPairs(cachedRouteListNoSig));
      }

      const cachedUnitGroups = parseCachedJson(cachedUnitGroupsRaw, []);
      if (Array.isArray(cachedUnitGroups) && cachedUnitGroups.length > 0) {
        unit_groups.set(cachedUnitGroups);
      }

      const cachedTravelCrtl = parseCachedJson(cachedTravelCrtlRaw, []);
      if (Array.isArray(cachedTravelCrtl) && cachedTravelCrtl.length > 0) {
        travel_crtl.set(cachedTravelCrtl);
      }

      const cachedGeos = parseCachedJson(cachedGeoListRaw, []);
      if (Array.isArray(cachedGeos) && cachedGeos.length > 0) {
        geos.set(cachedGeos);
      }

      const normalizedGeoListWks = normalizeGeoListWks(
        parseCachedJson(cachedGeoListWksRaw, {})
      );
      if (normalizedGeoListWks.geosList.length > 0) {
        geos.set(normalizedGeoListWks.geosList);
      }
      if (Object.keys(normalizedGeoListWks.geosFullMap).length > 0) {
        geos_full.set(normalizedGeoListWks.geosFullMap);
      }

      const cachedGeoClassList = parseCachedJson(cachedGeoClassListRaw, []);
      if (Array.isArray(cachedGeoClassList) && cachedGeoClassList.length > 0) {
        geos_class_list.set(cachedGeoClassList);
        geo_class_full.set(buildGeoClassFull(cachedGeoClassList));
      }

      const cachedGeosClass = parseCachedJson(cachedGeosClassRaw, {});
      if (cachedGeosClass && typeof cachedGeosClass === "object") {
        geos_class.set(cachedGeosClass);
      }

      const cachedGeosJoined = parseCachedJson(cachedGeosJoinedRaw, {});
      if (cachedGeosJoined && typeof cachedGeosJoined === "object") {
        geos_joined.set(cachedGeosJoined);
      }

      const cachedGeosClassJoin = parseCachedJson(cachedGeosClassJoinRaw, {});
      if (cachedGeosClassJoin && typeof cachedGeosClassJoin === "object") {
        geos_class_join.set(cachedGeosClassJoin);
      }

      const cachedZoneList = parseCachedJson(cachedZoneListRaw, []);
      if (Array.isArray(cachedZoneList) && cachedZoneList.length > 0) {
        const normalizedZones = buildZoneStores(cachedZoneList);
        zones_list.set(cachedZoneList);
        zones.set(normalizedZones.zoneMap);
        zone_full.set(normalizedZones.zoneFullMap);
      }

      const cachedPoliList = parseCachedJson(cachedPoliListRaw, []);
      if (Array.isArray(cachedPoliList) && cachedPoliList.length > 0) {
        const normalizedPoli = buildPoliStores(cachedPoliList);
        poli_list.set(cachedPoliList);
        poli.set(normalizedPoli.poliMap);
        poli_full.set(normalizedPoli.poliFullMap);
      }

      const cachedPoli = parseCachedJson(cachedPoliRaw, {});
      if (
        cachedPoli &&
        typeof cachedPoli === "object" &&
        Object.keys(cachedPoli).length > 0
      ) {
        poli.set(cachedPoli);
      }

      const cachedMonitorLive = parseCachedJson(cachedMonitorLiveRaw, {});
      if (cachedMonitorLive && typeof cachedMonitorLive === "object") {
        hydratedMonitorLiveSnapshot = cachedMonitorLive;
        if (
          Object.keys(hydratedMonitorLiveSnapshot).length > 0 &&
          Object.keys($live).length === 0
        ) {
          live.set(hydratedMonitorLiveSnapshot);
        }
      }

      const cachedMonitorTravels = parseCachedJson(cachedMonitorTravelsRaw, {});
      if (cachedMonitorTravels && typeof cachedMonitorTravels === "object") {
        hydratedMonitorTravelsSnapshot = cachedMonitorTravels;
        if (
          Object.keys(hydratedMonitorTravelsSnapshot).length > 0 &&
          Object.keys($travels).length === 0
        ) {
          travels.set(hydratedMonitorTravelsSnapshot);
        }
      }
    } catch (_error) {}
  }

  async function emitSessionTouch() {
    if (!socket_query.connected) {
      return;
    }
    const login_ = await login_db.getItem("login_");
    if (!login_) {
      return;
    }
    socket_query.emit("session_touch", buildQuerySessionMeta());
  }

  function stopSessionTouch() {
    if (session_touch_timer) {
      clearInterval(session_touch_timer);
      session_touch_timer = null;
    }
  }

  function startSessionTouch() {
    stopSessionTouch();
    session_touch_timer = setInterval(() => {
      emitSessionTouch();
    }, SESSION_TOUCH_INTERVAL_MS);
  }

  document.addEventListener("visibilitychange", () => {
    emitSessionTouch();
  });
  window.addEventListener("pagehide", () => {
    emitSessionTouch();
  });
  socket_query.on("disconnect", () => {
    stopSessionTouch();
  });

  const GOOGLE_MAPS_FONT_URL_PATTERNS = [
    /^https:\/\/fonts\.googleapis\.com\/css\?family=Roboto/i,
    /^https:\/\/fonts\.googleapis\.com\/css2\?family=Roboto/i,
    /^https:\/\/fonts\.googleapis\.com\/css\?family=Google\+Sans/i,
    /^https:\/\/fonts\.googleapis\.com\/css2\?family=Google\+Sans/i,
    /^https:\/\/fonts\.googleapis\.com\/css2\?family=Google\+Sans\+Text/i,
  ];
  let google_maps_font_guard_installed = false;

  function shouldBlockGoogleMapsFontNode(node) {
    if (!node || node.tagName !== "LINK") {
      return false;
    }

    let href = typeof node.href === "string" ? node.href : "";
    if (!href) {
      return false;
    }

    return GOOGLE_MAPS_FONT_URL_PATTERNS.some((pattern) => pattern.test(href));
  }

  function installGoogleMapsFontGuard() {
    if (google_maps_font_guard_installed) {
      return;
    }

    let head = document.head;
    if (!head) {
      return;
    }

    let originalAppendChild = head.appendChild.bind(head);
    let originalInsertBefore = head.insertBefore.bind(head);

    head.appendChild = function (node) {
      if (shouldBlockGoogleMapsFontNode(node)) {
        return node;
      }
      return originalAppendChild(node);
    };

    head.insertBefore = function (node, referenceNode) {
      if (shouldBlockGoogleMapsFontNode(node)) {
        return node;
      }
      return originalInsertBefore(node, referenceNode);
    };

    google_maps_font_guard_installed = true;
  }

  const GOOGLE_MAPS_BOOTSTRAP_STATE_KEY = "__vector_google_maps_bootstrap__";
  const GOOGLE_MAPS_IDLE_TIMEOUT_MS = 1500;
  const GOOGLE_MAPS_FALLBACK_DELAY_MS = 250;
  const GOOGLE_MAPS_DEFERRED_PATHS = ["/", "/app.html", "/app_driver.html"];
  var google_lic = document.getElementById("google_lic").getAttribute("value");

  function getGoogleMapsBootstrapState() {
    if (!window[GOOGLE_MAPS_BOOTSTRAP_STATE_KEY]) {
      window[GOOGLE_MAPS_BOOTSTRAP_STATE_KEY] = {
        promise: null,
        scheduled: false,
        script: null,
      };
    }

    return window[GOOGLE_MAPS_BOOTSTRAP_STATE_KEY];
  }

  function resolveGoogleMapsBootstrap() {
    map_ready.set(1);
    return window.google && window.google.maps ? window.google.maps : null;
  }

  function loadGoogleMapsBootstrap() {
    const state = getGoogleMapsBootstrapState();

    if (window.google && window.google.maps) {
      state.promise = Promise.resolve(resolveGoogleMapsBootstrap());
      return state.promise;
    }

    if (state.promise) {
      return state.promise;
    }

    installGoogleMapsFontGuard();

    state.promise = new Promise((resolve, reject) => {
      let script = state.script;

      function handleReady() {
        resolve(resolveGoogleMapsBootstrap());
      }

      function handleError(error) {
        if (script && script.parentNode) {
          script.parentNode.removeChild(script);
        }
        state.script = null;
        state.promise = null;
        state.scheduled = false;
        reject(error);
      }

      window.initMap = handleReady;

      if (!script || !document.head.contains(script)) {
        script = document.querySelector(
          'script[data-vector-google-maps="1"],script[src*="maps.googleapis.com/maps/api/js"]'
        );
      }

      if (!script) {
        script = document.createElement("script");
        script.src =
          "https://maps.googleapis.com/maps/api/js?key=" +
          google_lic +
          "&callback=initMap";
        script.defer = true;
        script.async = true;
        script.setAttribute("data-vector-google-maps", "1");
        document.head.appendChild(script);
      }

      state.script = script;

      script.addEventListener(
        "load",
        function () {
          if (window.google && window.google.maps) {
            handleReady();
          }
        },
        { once: true }
      );
      script.addEventListener("error", handleError, { once: true });
    });

    return state.promise;
  }

  function scheduleGoogleMapsBootstrap() {
    if (window.location.pathname == "/embed_dtc.html") {
      return;
    }

    if (GOOGLE_MAPS_DEFERRED_PATHS.indexOf(window.location.pathname) == -1) {
      loadGoogleMapsBootstrap().catch(() => {});
      return;
    }

    const state = getGoogleMapsBootstrapState();
    if (state.scheduled) {
      return;
    }

    state.scheduled = true;

    const startBootstrap = function () {
      loadGoogleMapsBootstrap().catch(() => {});
    };

    if (typeof window.requestIdleCallback === "function") {
      window.requestIdleCallback(startBootstrap, {
        timeout: GOOGLE_MAPS_IDLE_TIMEOUT_MS,
      });
      return;
    }

    window.setTimeout(startBootstrap, GOOGLE_MAPS_FALLBACK_DELAY_MS);
  }

  scheduleGoogleMapsBootstrap();

  let geos_worker,
    travel_worker,
    monitor_worker,
    trips_worker,
    routes_worker,
    unit_worker,
    embed_dtc_worker,
    monitorWorker;
  let user_level = 0;
  let user_alerts = true;
  if (window.location.pathname != "/") {
    window.document.body.classList.add("general");
  }
  if (
    window.location.pathname == "/" ||
    window.location.pathname == "/app.html" ||
    window.location.pathname == "/app_driver.html"
  ) {
    // Load Local variables
    let workstation_units = localStorage.getItem("workstation_units")
      ? JSON.parse(localStorage.getItem("workstation_units"))
      : [];
    unit_list_ws.set(workstation_units);
    hydrateInitialCatalogCache();

    // Mega Wokers
    let live_p = { ...hydratedMonitorLiveSnapshot };
    hydratedMonitorLiveSnapshot = null;
    let table_p = [];
    let table_index_by_modid = Object.create(null);
    scheduleWorkerBootstrap("unit", () => {
      unit_worker = new Worker("js/unit_worker.js");
      unit_worker.onmessage = function (data) {
        //console.log(data.data);
        if (data.data.type == "global") {
          if (data.data.name == "units_list") {
            table_index_by_modid = Object.create(null);
            table_p = data.data.data.map((modid, index) => {
              table_index_by_modid[modid] = index;
              return { modid };
            });
            units_list.set([...data.data.data]);
            registerPortalBootstrapSignal("units");
          }
          if (data.data.name == "nicks_list") nicks_list.set(data.data.data);
          if (data.data.name == "live") {
            applyLiveWorkerUpdates(
              Array.isArray(data.data.updates)
                ? data.data.updates
                : [{ modid: data.data.modid, data: data.data.data }]
            );
          }
          //if(data.data.name=="table_pos") table_pos.set([...data.data.data]);
        }
      };
      unit_worker.postMessage({
        type: "main_thread_batch",
        message: { intervalMs: MONITOR_WORKER_MAIN_THREAD_BATCH_MS },
      });
      unit_worker.postMessage({
        type: "server",
        message: serverdb,
      });
    });
    function compare(a, b) {
      return b.last_comm - a.last_comm;
    }

      scheduleWorkerBootstrap("trips", () => {
        trips_worker = new Worker("js/trips_worker.js");
        trips_worker.onmessage = function (data) {
          if (data.data.type == "global") {
            if (data.data.name == "drivers_list") drivers_list.set(data.data.data);
            if (data.data.name == "drivers") drivers.set(data.data.data);
            if (data.data.name == "unit_groups") unit_groups.set(data.data.data);
            if (data.data.name == "travel_crtl") {
              travel_crtl.set(data.data.data);
              registerPortalBootstrapSignal("trips");
            }
            if (data.data.name == "travels_list") {
              travels_list.set(data.data.data);
              registerPortalBootstrapSignal("trips");
            }
            if (data.data.name == "unit_config") unit_config.set(data.data.data);
            if (data.data.name == "unit_types") unit_types.set(data.data.data);
            if (data.data.name == "reports_cron") reports_cron.set(data.data.data);
            if (data.data.name == "last_message_date")
              last_message_date.set(data.data.data);
          }
        };
      trips_worker.postMessage({
        type: "server",
        message: serverdb,
      });
    });

      scheduleWorkerBootstrap("route", () => {
        routes_worker = new Worker("js/routes_worker.js");
        routes_worker.onmessage = function (data) {
          if (data.data.type == "global") {
            if (data.data.name == "route_list") {
              route_list.set([...data.data.data]);
              registerPortalBootstrapSignal("routes");
            }
            if (data.data.name == "route_list_d") route_list_d.set(data.data.data);
            if (data.data.name == "route_list_nosig")
              route_list_nosig.set([...data.data.data]);
            if (data.data.name == "route_list_nosig_d")
              route_list_nosig_d.set(data.data.data);
          }
        };
      routes_worker.postMessage({
        type: "server",
        message: serverdb,
      });
    });

    let travels_p = { ...hydratedMonitorTravelsSnapshot };
    hydratedMonitorTravelsSnapshot = null;

    // --- Store cascade throttle: batch store.set() notifications ---
    let _storeDirtyLive = false;
    let _storeDirtyTravels = false;
    let _storeDirtyTable = false;
    let _storeFlushTimer = null;
    const STORE_FLUSH_MS = 900;
    function scheduleStoreFlush() {
      if (_storeFlushTimer) return;
      _storeFlushTimer = setTimeout(flushStores, STORE_FLUSH_MS);
    }
    function flushStores() {
      _storeFlushTimer = null;
      if (_storeDirtyLive) {
        live.set(live_p);
        _storeDirtyLive = false;
      }
      if (_storeDirtyTravels) {
        travels.set(travels_p);
        _storeDirtyTravels = false;
      }
      if (_storeDirtyTable) {
        table_p.sort(compare);
        table_index_by_modid = Object.create(null);
        for (let index = 0; index < table_p.length; index++) {
          if (table_p[index] && table_p[index].modid) {
            table_index_by_modid[table_p[index].modid] = index;
          }
        }
        table_pos.set([...table_p]);
        _storeDirtyTable = false;
      }
    }

    function ensureHydratedLiveSnapshot() {
      if (
        Object.keys(live_p).length === 0 &&
        hydratedMonitorLiveSnapshot &&
        Object.keys(hydratedMonitorLiveSnapshot).length > 0
      ) {
        live_p = { ...hydratedMonitorLiveSnapshot };
        hydratedMonitorLiveSnapshot = null;
      }
    }

    function applyLiveWorkerUpdates(updates) {
      if (!Array.isArray(updates) || updates.length === 0) {
        return;
      }

      ensureHydratedLiveSnapshot();
      let processedUpdates = 0;

      for (const update of updates) {
        if (!update || update.modid == null) {
          continue;
        }

        live_p[update.modid] = update.data;

        const tableIndex = table_index_by_modid[update.modid];
        const tableEntry = {
          ...update.data,
          modid: update.modid,
        };
        if (typeof tableIndex === "number") {
          table_p[tableIndex] = tableEntry;
        } else {
          table_index_by_modid[update.modid] = table_p.length;
          table_p.push(tableEntry);
        }

        processedUpdates++;
      }

      if (processedUpdates === 0) {
        return;
      }

      _storeDirtyLive = true;
      _storeDirtyTable = true;
      scheduleMonitorCachePersist(MONITOR_LIVE_CACHE_KEY, live_p);
      scheduleStoreFlush();
    }

    function ensureHydratedTravelsSnapshot() {
      if (
        Object.keys(travels_p).length === 0 &&
        hydratedMonitorTravelsSnapshot &&
        Object.keys(hydratedMonitorTravelsSnapshot).length > 0
      ) {
        travels_p = { ...hydratedMonitorTravelsSnapshot };
        hydratedMonitorTravelsSnapshot = null;
      }
    }

    function applyTravelWorkerUpdates(updates) {
      if (!Array.isArray(updates) || updates.length === 0) {
        return;
      }

      ensureHydratedTravelsSnapshot();
      let processedUpdates = 0;

      for (const update of updates) {
        if (!update || update.modid == null) {
          continue;
        }

        travels_p[update.modid] = update.data;
        processedUpdates++;
      }

      if (processedUpdates === 0) {
        return;
      }

      _storeDirtyTravels = true;
      scheduleMonitorCachePersist(MONITOR_TRAVELS_CACHE_KEY, travels_p);
      scheduleStoreFlush();
    }

    scheduleWorkerBootstrap("monitor", () => {
      monitor_worker = new Worker("js/monitor_worker.js");
      monitor_worker.onmessage = function (data) {
        if (data.data.type == "global") {
          if (data.data.name == "travels") {
            applyTravelWorkerUpdates(
              Array.isArray(data.data.updates)
                ? data.data.updates
                : [{ modid: data.data.modid, data: data.data.data }]
            );
            registerPortalBootstrapSignal("monitor");
          }
          if (data.data.name == "unit_list_ws_real") {
            unit_list_ws_real.set(data.data.data);
            registerPortalBootstrapSignal("monitor");
          }
        }
      };
      monitor_worker.postMessage({
        type: "main_thread_batch",
        message: { intervalMs: MONITOR_WORKER_MAIN_THREAD_BATCH_MS },
      });
      monitor_worker.postMessage({
        type: "unit_list_ws",
        message: $unit_list_ws,
      });
      monitor_worker.postMessage({
        type: "server",
        message: serverdb,
      });
    });

    scheduleWorkerBootstrap("travel", () => {
      travel_worker = new Worker("js/travel_worker.js");
      travel_worker.onmessage = function (data) {
        if (data.data.type == "global") {
        }
      };
      travel_worker.postMessage({
        type: "server",
        message: serverdb,
      });
    });

    monitorWorker = new Worker("js/worker-monitor.js");

    scheduleWorkerBootstrap("geo", () => {
      geos_worker = new Worker("js/geos_worker.js");
      geos_worker.onmessage = function (data) {
        if (data.data.type == "global") {
          if (data.data.name == "geos_map") geos_map.set(data.data.data);
          if (data.data.name == "geos") {
            geos.set([...data.data.data]);
            registerPortalBootstrapSignal("geos");
          }
          if (data.data.name == "geos_class_list")
            geos_class_list.set([...data.data.data]);
          if (data.data.name == "geos_class") geos_class.set(data.data.data);
          if (data.data.name == "geos_joined") geos_joined.set(data.data.data);
          if (data.data.name == "geos_class_join")
            geos_class_join.set(data.data.data);
          if (data.data.name == "geos_full") {
            geos_full.set(data.data.data);
            registerPortalBootstrapSignal("geos");
          }
          if (data.data.name == "geo_class_full")
            geo_class_full.set(data.data.data);
          if (data.data.name == "zones_list") zones_list.set([...data.data.data]);
          if (data.data.name == "zones") zones.set(data.data.data);
          if (data.data.name == "zone_full") zone_full.set(data.data.data);
          if (data.data.name == "poli_list") poli_list.set([...data.data.data]);
          if (data.data.name == "poli") poli.set(data.data.data);
          if (data.data.name == "poli_full") poli_full.set(data.data.data);
        }
      };
      geos_worker.postMessage({
        type: "server",
        message: serverdb,
      });
    });

    socket_query.on("hello", async function (data) {
      await emitStoredHello();
    });

    socket_query.on("user_info", async function (data) {
      if (data != null) {
        const userInfo = JSON.parse(data);
        const currentLoginFeedback = get(login_feedback);
        const isPendingLoginFlow =
          currentLoginFeedback.phase == "authenticating" ||
          currentLoginFeedback.phase == "waiting-response" ||
          currentLoginFeedback.phase == "restoring-session";
        if (window.location.pathname == "/" && $menu == 0 && !isPendingLoginFlow) {
          return;
        }
        const shouldShowPostLoginFeedback =
          window.location.pathname == "/" && isPendingLoginFlow;

        user_level = userInfo["level"];
        group.set(userInfo["group"]);
        user_alerts =
          userInfo["alerts"] == null ? true : userInfo["alerts"];
        //menu.set(await base_db.getItem('menu_base'));
        if (userInfo["type"] == "driver") {
          restoring_session = false;
          clearRestoreFeedbackTimer();
          finishPortalBootstrap();
          setLoginFeedbackState();
          driver_name.set(userInfo["name"]);
          driver_id.set(userInfo["driver_id"]);
          startSessionTouch();
          emitSessionTouch();
          if (window.location.pathname != "/app_driver.html")
            window.location.replace("/app_driver.html");
          socket_query.emit("driver_reports");
          return;
        } else if ($menu == 0) {
          menu.set(6);
          login_db.setItem("menu_base", 6);
          window.document.body.classList.add("central2");
        }
        if (shouldShowPostLoginFeedback) {
          beginPortalBootstrap();
        } else if (
          currentLoginFeedback.phase == "authenticating" ||
          currentLoginFeedback.phase == "waiting-response" ||
          currentLoginFeedback.phase == "restoring-session"
        ) {
          restoring_session = false;
          setLoginFeedbackState();
        }
        startSessionTouch();
        emitSessionTouch();
        socket_query.emit("portal_notification");
        socket_query.emit("genesys_sip");
        socket_query.emit("maps_config");
        socket_query.emit("input_self_test");
        if (user_level >= 4) socket_query.emit("user_list");
        if (user_level >= 4) socket_query.emit("alerts_list");
        if (user_level >= 4) socket_query.emit("reports");
        if (user_level >= 4) socket_query.emit("driver_reports");
        if (user_level >= 4) socket_query.emit("hos_config");
        if (user_level >= 4) socket_query.emit("continue_recording");
        if (user_level >= 4) socket_query.emit("alert_management");
        if (user_level >= 4) socket_query.emit("custom_options");
      } else {
        await resetPortalToLogin();
      }
    });

    socket_query.on("user_invalid", async function () {
      await resetPortalToLogin({
        alertMessage: "Usuario o contraseña incorrectos",
        alertType: "alert-danger",
      });
    });

    socket_query.on("redirection_mode", async function (data) {
      window.location.replace(data);
    });

    socket_query.on("redirection_route", async function (data) {
      if (window.location.pathname != data) {
        await login_db.setItem("99");
        window.location.replace(data);
      }
    });

    socket_query.on("user_list", async function (data) {
      let out = [];
      for (var x in data) {
        if (data[x].level == 0) data[x].level_text = "Invitado";
        if (data[x].level == 1) data[x].level_text = "Operador";
        if (data[x].level == 2) data[x].level_text = "Supervisor";
        if (data[x].level == 3) data[x].level_text = "Administrador";
        if (data[x].level == 4) data[x].level_text = "Super Administrador";
        if (data[x].level > 4) data[x].level_text = "Dios";
        out.push(data[x]);
      }
      out.sort((a, b) => a.user.localeCompare(b.user));
      users_list.set(out);
    });

    socket_query.on("alerts_list", async function (data) {
      alerts_list.set(data);
    });

    socket_query.on("reports", async function (data) {
      reports.set(data);
    });

    socket_query.on("driver_reports", async function (data) {
      driver_reports.set(data);
    });

    socket_query.on("hos_config", async function (data) {
      hos_config.set(data);
    });

    socket_query.on("continue_recording", async function (data) {
      continue_recording.set(data);
    });

    socket_query.on("genesys_sip", async function (data) {
      genesys_key.set(data);
    });

    socket_query.on("alert_management", async function (data) {
      alert_management.set(data);
    });

    socket_query.on("custom_options", async function (data) {
      custom_options.set(data);
    });

    socket_query.on("chats_", async function (data, data2) {
      let chat1 = await chats_db.getItem(data);
      if (chat1 != null) {
        chat1 = JSON.parse(chat1);
        data2 = JSON.parse(data2);
        chat1.chats.push(data2);
        if (data2.type == 0) {
          last_message_date.update((n) => {
            n[data] = data2.date;
            return n;
          });
        }
        await chats_db.setItem(data, JSON.stringify(chat1));
      }
    });

    socket_query.on("maps_config", async function (data) {
      route_confidence.set(data.route_confidence);
      registerPortalBootstrapSignal("config");
    });

    socket_query.on("input_self_test", async function (data) {
      input_self_test.set(data);
      registerPortalBootstrapSignal("config");
    });

    hydrateStoredSessionState();

    /*
    base_db.getItem('nick_list',function(err, data){
      if(data!=null)
      {nicks_list.set(JSON.parse(data));}
    });
    base_db.getItem('route_list',function(err, data){
      if(data!=null)
      {route_list.set(data);}
    });
    base_db.getItem('geos_joined',function(err, data){
      if(data!=null)
      {geos_joined.set(data);}
    });
    base_db.getItem('geos_class_join',function(err, data){
      if(data!=null)
      {geos_class_join.set(data);}
    });
    */
  }
  if (window.location.pathname == "/embed_dtc.html") {
    embed_dtc_worker = new Worker("js/embed_dtc_worker.js");
    embed_dtc_worker.onmessage = function (data) {
      if (data.data.type == "global") {
        if (data.data.name == "units_list") {
          units_list.set([...data.data.data]);
        }
        if (data.data.name == "embed_nicks") {
          nicks_list.set(JSON.parse(data.data.data));
        }
        if (data.data.name == "alert") {
          alert(data.data.data);
        }
        if ((data.data.name = "dtc_count")) {
          dtc_count.set(data.data.data);
        }
      }
    };
    embed_dtc_worker.postMessage({
      type: "server",
      message: serverdb,
    });
  }
  if (window.location.pathname == "/embed_ecm.html") {
    let live_p = {};
    let table_p = [];
    unit_worker = new Worker("js/unit_worker.js");
    unit_worker.onmessage = function (data) {
      //console.log(data.data);
      if (data.data.type == "global") {
        if (data.data.name == "units_list") {
          table_p = [];
          for (var x in data.data.data) {
            table_p[x] = { modid: data.data.data[x] };
          }
          units_list.set([...data.data.data]);
        }
        if (data.data.name == "nicks_list") nicks_list.set(data.data.data);
        if (data.data.name == "live") {
          live_p[data.data.modid] = data.data.data;
          live.set(live_p);
          for (var u in table_p) {
            if (table_p[u]["modid"] == data.data.modid) {
              table_p[u] = data.data.data;
            }
          }
          table_p.sort(compare);
          table_pos.set([...table_p]);
        }
        //if(data.data.name=="table_pos") table_pos.set([...data.data.data]);
      }
    };
    unit_worker.postMessage({
      type: "server",
      message: serverdb,
    });
    function compare(a, b) {
      return b.last_comm - a.last_comm;
    }
  }
  if (window.location.pathname == "/embed_mensajes.html") {
    socket_query.on("hello", async function (data) {
      await emitStoredHello();
    });

    socket_query.on("user_info", async function (data) {
      if (data != null) {
        user_level = JSON.parse(data)["level"];
        //menu.set(await base_db.getItem('menu_base'));
        if ($menu == 0) {
          menu.set(1);
          login_db.setItem("menu_base", 1);
          window.document.body.classList.add("central2");
        }
        socket_query.emit("portal_notification");
      } else {
        login_db.setItem("login_", "");
        menu.set(0);
        login_db.setItem("menu_base", 0);
      }
    });

    trips_worker = new Worker("js/embed_trips_worker.js");
    trips_worker.onmessage = function (data) {
      if (data.data.type == "global") {
        if (data.data.name == "drivers_list") drivers_list.set(data.data.data);
        if (data.data.name == "drivers") drivers.set(data.data.data);
        if (data.data.name == "unit_groups") unit_groups.set(data.data.data);
        if (data.data.name == "travel_crtl") travel_crtl.set(data.data.data);
        if (data.data.name == "travels_list") travels_list.set(data.data.data);
        if (data.data.name == "unit_config") unit_config.set(data.data.data);
        if (data.data.name == "unit_types") unit_types.set(data.data.data);
        if (data.data.name == "reports_cron") reports_cron.set(data.data.data);
      }
    };
    trips_worker.postMessage({
      type: "server",
      message: serverdb,
    });
  }
  if (window.location.pathname == "/embed_recorridos.html") {
    let live_p = {};
    let table_p = [];
    unit_worker = new Worker("js/unit_worker.js");
    unit_worker.onmessage = function (data) {
      //console.log(data.data);
      if (data.data.type == "global") {
        if (data.data.name == "units_list") {
          table_p = [];
          for (var x in data.data.data) {
            table_p[x] = { modid: data.data.data[x] };
          }
          units_list.set([...data.data.data]);
        }
        if (data.data.name == "nicks_list") nicks_list.set(data.data.data);
        if (data.data.name == "live") {
          live_p[data.data.modid] = data.data.data;
          live.set(live_p);
          for (var u in table_p) {
            if (table_p[u]["modid"] == data.data.modid) {
              table_p[u] = data.data.data;
            }
          }
          table_p.sort(compare);
          table_pos.set([...table_p]);
        }
        //if(data.data.name=="table_pos") table_pos.set([...data.data.data]);
      }
    };
    unit_worker.postMessage({
      type: "server",
      message: serverdb,
    });
    function compare(a, b) {
      return b.last_comm - a.last_comm;
    }
  }
  if (window.location.pathname == "/embed_monitor.html") {
    let live_p = {};
    let table_p = [];
    unit_worker = new Worker("js/unit_worker.js");
    unit_worker.onmessage = function (data) {
      //console.log(data.data);
      if (data.data.type == "global") {
        if (data.data.name == "units_list") {
          table_p = [];
          for (var x in data.data.data) {
            table_p[x] = { modid: data.data.data[x] };
          }
          units_list.set([...data.data.data]);
        }
        if (data.data.name == "nicks_list") nicks_list.set(data.data.data);
        if (data.data.name == "live") {
          live_p[data.data.modid] = data.data.data;
          live.set(live_p);
          for (var u in table_p) {
            if (table_p[u]["modid"] == data.data.modid) {
              table_p[u] = data.data.data;
            }
          }
          table_p.sort(compare);
          table_pos.set([...table_p]);
        }
        //if(data.data.name=="table_pos") table_pos.set([...data.data.data]);
      }
    };
    unit_worker.postMessage({
      type: "server",
      message: serverdb,
    });
    function compare(a, b) {
      return b.last_comm - a.last_comm;
    }

    let travels_p = {};
    monitor_worker = new Worker("js/monitor_worker.js");
    monitor_worker.onmessage = function (data) {
      if (data.data.type == "global") {
        if (data.data.name == "travels") {
          travels_p[data.data.modid] = data.data.data;
          travels.set(travels_p);
        }
      }
    };
    monitor_worker.postMessage({
      type: "server",
      message: serverdb,
    });
  }
  if (window.location.pathname != "/") {
    window.document.body.classList.add("central2");
  }

  // Service Worker
  let subscription_push = null;
  if (navigator.serviceWorker) {
    navigator.serviceWorker.ready.then(function (sw) {
      sw.pushManager
        .subscribe({
          userVisibleOnly: true,
          applicationServerKey: urlBase64ToUint8Array(
            "BMPbU7svL5oVJn2SS9cVMDVYZj6BRCwvs2oayl4H1UojOVGZdzr6dUGWGJK9GwWV2It6WTEt3NJs4jOrX5wu2jQ"
          ),
        })
        .then(function (subscription) {
          subscription_push = subscription;
        });
    });
  }
  $: {
    if (subscription_push && user_level != 0) {
      socket_query.emit("subscription_push", subscription_push);
    }
  }
  $: if (window.location.pathname == "/" && $menu == 0) {
    const currentLoginFeedback = get(login_feedback);
    if (
      currentLoginFeedback.phase != "authenticating" &&
      currentLoginFeedback.phase != "waiting-response" &&
      currentLoginFeedback.phase != "restoring-session"
    ) {
      clearPortalBootstrapTimers();
      resetPortalBootstrapSignals();
      restoring_session = false;
      if (currentLoginFeedback.phase == "loading-panel") {
        setLoginFeedbackState();
      }
    }
  }
  // Convertir la clave pública VAPID de Base64 a Uint8Array
  function urlBase64ToUint8Array(base64String) {
    const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding)
      .replace(/-/g, "+")
      .replace(/_/g, "/");

    const rawData = atob(base64);
    return Uint8Array.from([...rawData].map((char) => char.charCodeAt(0)));
  }
</script>

{#if window.location.pathname == "/mapa.html"}
  <Mapa />
{:else if window.location.pathname == "/mapa_travel.html"}
  <Mapa_travel {socket_query} />
{:else if window.location.pathname == "/embed_dtc.html"}
  <Embed_dtc {socket_query} {embed_dtc_worker} {dtc_db} />
{:else if window.location.pathname == "/embed_ecm.html"}
  <Embed_ecm {units_travel_db} {socket_query} {vins_db} {ecm_db} />
{:else if window.location.pathname == "/embed_mensajes.html"}
  <Embed_mensajes {socket_query} {chats_db} />
{:else if window.location.pathname == "/embed_recorridos.html"}
  <Embed_recorridos {socket_query} {units_travel_db} />
{:else if window.location.pathname == "/embed_monitor.html"}
  <Embed_monitor {socket_query} {routes_db} {units_travel_db} />
{:else if window.location.pathname == "/app.html"}
  <Travel_app {socket_query} />
{:else if window.location.pathname == "/app_driver.html"}
  <DriverApp
    {socket_query}
    {login_db}
    {monitor_worker}
    {unit_worker}
    {geos_worker}
    {travel_worker}
    {trips_worker}
    {routes_worker}
    {routes_db}
    {chats_db}
  />
{:else if $menu == 0}
  <Login
    {unit_worker}
    {routes_worker}
    {trips_worker}
    {travel_worker}
    {geos_worker}
    {socket_query}
    {monitor_worker}
    {login_db}
    {login_state_ready}
    {restoring_session}
    cancelSavedSessionRestore={() =>
      resetPortalToLogin({
        alertMessage:
          "Sesión guardada descartada. Ingresa tus credenciales para continuar.",
        alertType: "alert-info",
      })}
  />
{:else}
  <Central
    {dtc_db}
    {ecm_db}
    {vins_db}
    {user_level}
    {user_alerts}
    {socket_query}
    {units_travel_db}
    {login_db}
    {routes_db}
    {chats_db}
    {travel_db}
    {monitor_worker}
    {unit_worker}
    {geos_worker}
    {travel_worker}
    {trips_worker}
    {routes_worker}
    {protocol_db}
    {monitorWorker}
  />
{/if}

{#if
  $login_feedback.active &&
  $login_feedback.phase == "restoring-session" &&
  restoring_session &&
  $menu != 0
}
  <div class="login-feedback-overlay login-feedback-overlay--blocking">
    <div class="login-feedback-card" role="status" aria-live="polite">
      <div class="login-feedback-spinner" />
      <strong>{$login_feedback.title}</strong>
      <p>{$login_feedback.detail}</p>
      {#if $login_feedback.slow}
        <p class="login-feedback-note">
          Si esta sesión ya no es válida, puedes volver al login ahora.
        </p>
      {/if}
      <button
        class="mdc-button mdc-button--outlined login-feedback-action"
        type="button"
        on:click={() =>
          resetPortalToLogin({
            alertMessage:
              "Sesión guardada descartada. Ingresa tus credenciales para continuar.",
            alertType: "alert-info",
          })}
      >
        <span class="mdc-button__ripple" />
        <span class="mdc-button__label">Ingresar con otra cuenta</span>
      </button>
    </div>
  </div>
{/if}

{#if
  $login_feedback.active &&
  $login_feedback.phase == "loading-panel" &&
  $menu != 0
}
  <div class="login-feedback-overlay login-feedback-overlay--passive">
    <div class="login-feedback-toast" role="status" aria-live="polite">
      <div class="login-feedback-toast__header">
        <strong>{$login_feedback.title}</strong>
        <span>{$login_feedback.completed}/{$login_feedback.total}</span>
      </div>
      <p>{$login_feedback.detail}</p>
      <div class="login-feedback-progress">
        <span
          style={`width:${Math.round(($login_feedback.progress || 0) * 100)}%;`}
        />
      </div>
      <div class="login-feedback-steps">
        {#each $login_feedback.steps as step}
          <span class:done={step.done} class="login-feedback-step">
            {step.done ? "✓" : "…"} {step.label}
          </span>
        {/each}
      </div>
    </div>
  </div>
{/if}

<style>
  :global(html) {
    height: 100%;
  }
  :global(body) {
    display: flex;
    height: 100%;
    width: 100%;
    align-items: center;
    text-align: center;
    background-color: #ffffff;
    background-image: url("../img/fondo.png");
    background-size: cover;
    background-attachment: fixed;
  }
  :global(body.central) {
    line-height: 1;
    height: 100%;
    width: 100%;
    min-height: 3rem;
    padding-top: 2.5rem;
    background-color: #f5f5f5;
    padding-bottom: 0rem;
    font-size: 0.85rem;
  }
  :global(body.central2) {
    display: flex;
    line-height: 1;
    height: 100%;
    width: 100%;
    padding-top: 0px;
    padding-bottom: 0px;
    align-items: normal;
    text-align: left;
    font-size: 0.85rem;
    background-image: none;
    background-color: #f5f5f5;
  }
  :global(body.general) {
    line-height: 1;
    height: 100%;
    width: 100%;
    min-height: 3rem;
    padding-top: 0rem;
    background-color: #f5f5f5;
    padding-bottom: 0rem;
    font-size: 0.85rem;
    background-image: none;
  }
  .login-feedback-overlay {
    position: fixed;
    inset: 0;
    z-index: 1200;
    display: flex;
    justify-content: center;
  }
  .login-feedback-overlay--blocking {
    align-items: center;
    padding: 1.5rem;
    background: rgba(15, 23, 42, 0.28);
  }
  .login-feedback-overlay--passive {
    pointer-events: none;
    align-items: flex-start;
    padding: 1.5rem;
  }
  .login-feedback-card,
  .login-feedback-toast {
    width: min(92vw, 34rem);
    border-radius: 1rem;
    background: rgba(255, 255, 255, 0.97);
    box-shadow: 0 18px 48px rgba(15, 23, 42, 0.18);
    color: #1f2937;
  }
  .login-feedback-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.85rem;
    padding: 1.75rem 1.5rem;
    text-align: center;
  }
  .login-feedback-card strong,
  .login-feedback-toast strong {
    font-size: 1rem;
    line-height: 1.35;
  }
  .login-feedback-card p,
  .login-feedback-toast p {
    margin: 0;
    line-height: 1.45;
    color: #4b5563;
  }
  .login-feedback-note {
    font-size: 0.9rem;
  }
  .login-feedback-action {
    pointer-events: auto;
  }
  .login-feedback-spinner {
    width: 3rem;
    height: 3rem;
    border-radius: 50%;
    border: 0.28rem solid #dbeafe;
    border-top-color: #2563eb;
    animation: login-feedback-spin 0.9s linear infinite;
  }
  .login-feedback-toast {
    margin-top: 1.5rem;
    padding: 1rem 1.1rem;
  }
  .login-feedback-toast__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    margin-bottom: 0.45rem;
  }
  .login-feedback-progress {
    width: 100%;
    height: 0.42rem;
    margin-top: 0.85rem;
    overflow: hidden;
    border-radius: 999px;
    background: #e5e7eb;
  }
  .login-feedback-progress span {
    display: block;
    height: 100%;
    min-width: 0.8rem;
    border-radius: inherit;
    background: linear-gradient(90deg, #2563eb, #38bdf8);
    transition: width 180ms ease;
  }
  .login-feedback-steps {
    display: flex;
    flex-wrap: wrap;
    gap: 0.45rem;
    margin-top: 0.85rem;
  }
  .login-feedback-step {
    display: inline-flex;
    align-items: center;
    gap: 0.28rem;
    padding: 0.28rem 0.55rem;
    border-radius: 999px;
    background: #f3f4f6;
    color: #6b7280;
    font-size: 0.8rem;
    font-weight: 500;
  }
  .login-feedback-step.done {
    background: #dbeafe;
    color: #1d4ed8;
  }
  @keyframes login-feedback-spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
</style>
